import zwTh from "../messagesJson/zh-tw.json";
export const PartialMessages = {
    "zw-th": zwTh,
} as const;
